import type { TargetAndTransition, Transition, Variants } from 'framer-motion';

export const smoothEase: [number, number, number, number] = [0.22, 1, 0.36, 1];

export const routeTransition: Transition = {
  duration: 0.34,
  ease: smoothEase
};

export const revealTransition: Transition = {
  duration: 0.62,
  ease: smoothEase
};

export const staggerContainerVariants: Variants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.08
    }
  }
};

export const fadeUpVariants: Variants = {
  hidden: {
    opacity: 0,
    y: 24
  },
  show: {
    opacity: 1,
    y: 0,
    transition: revealTransition
  }
};

export const softPopVariants: Variants = {
  hidden: {
    opacity: 0,
    scale: 0.96,
    y: 18
  },
  show: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: revealTransition
  }
};

export const hoverLift: TargetAndTransition = {
  y: -6,
  scale: 1.01
};

export const tapPress: TargetAndTransition = {
  scale: 0.98
};
